/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SubscriptionTierStatus = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED'
} as const;
export type SubscriptionTierStatus = typeof SubscriptionTierStatus[keyof typeof SubscriptionTierStatus];


export function instanceOfSubscriptionTierStatus(value: any): boolean {
    for (const key in SubscriptionTierStatus) {
        if (Object.prototype.hasOwnProperty.call(SubscriptionTierStatus, key)) {
            if (SubscriptionTierStatus[key as keyof typeof SubscriptionTierStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubscriptionTierStatusFromJSON(json: any): SubscriptionTierStatus {
    return SubscriptionTierStatusFromJSONTyped(json, false);
}

export function SubscriptionTierStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionTierStatus {
    return json as SubscriptionTierStatus;
}

export function SubscriptionTierStatusToJSON(value?: SubscriptionTierStatus | null): any {
    return value as any;
}

export function SubscriptionTierStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SubscriptionTierStatus {
    return value as SubscriptionTierStatus;
}

